module.exports = __webpack_public_path__ + "static/media/thumbnail.e0857ac8.jpg";